/*
 * Authors: Koen, mariushirjanu, Triadi
 * Created: 13/11/2018
 */
import { Component, Input, OnInit } from '@angular/core';
import { GaValidateService } from '../formly/ga-validate.service';
import { TranslationService } from '../translation/translation.service';
import { DefaultFormDialogComponent } from '../message/dialogs/default-form-dialog.component';
import { ISubCompany } from '../../../type_definitions/datatypes';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../formly/ga-formly.service';
import { FormattingService } from '../services/formatting.service';
import { CountryDataService } from '../location/country-data.service';
import { UserDataService } from '../user/user-data.service';
import { EMAIL_SUFFIX_REGEX } from '../formly/ga-formly-validator.service';

export interface SubcompanyEditModel extends ISubCompany {
  signupUrl:string;
}

@Component({
  selector: 'subcompany-edit',
  templateUrl: '../message/dialogs/default-form-dialog.html'
})
export class SubcompanyEditComponent extends DefaultFormDialogComponent implements OnInit {
  @Input() public model:SubcompanyEditModel;
  private existingSubCompany:boolean;
  private countryField:IExtraFieldConfigurationObject;

  constructor(
    validateService:GaValidateService,
    translationService:TranslationService,
    private countryDataService:CountryDataService,
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    private userDataService:UserDataService
  ) {
    super(validateService, translationService);
  }

  public ngOnInit():void {
    super.ngOnInit();
    this.existingSubCompany = !!this.model?.id;
    this.fields = this.createFields();
    this.fillFields();
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const form:IExtraFieldConfigurationObject[] = [];

    if (this.model?.company) {
      form.push(
        this.formlyService.aValue('company', 'Company')
          .withFormat(this.formattingService.formatCompany)
          .build()
      );
    } else {
      form.push(
        this.formlyService.aSearch('company', 'Company')
          .isRequired()
          .withFormat(this.formattingService.formatCompany)
          .withUrl('rest/compman/companies')
          .build()
      );
    }

    form.push(
      this.formlyService.anInput('name', 'Subcompany')
        .isRequired()
        .build(),

      this.formlyService.anInput('internalId', 'Internal ID')
        .build(),

      this.countryField = this.formlyService.aSelect('country', 'Country')
        .withFormat(this.formattingService.formatCountry)
        .build(),

      this.formlyService.anInput('subCompanyEmail', 'Email')
        .build(),

      this.formlyService.anInput('emailSuffix', 'Email Suffixes')
        .withInfo('GA.GENERAL.EMAILSUFFIX_INFO')
        .showInfo()
        .withoutInfoOffset()
        .withPattern(EMAIL_SUFFIX_REGEX)
        .build(),

      this.formlyService.anInput('subCompanyPhoneNumber', 'Phone')
        .build(),

      this.formlyService.aTextarea('comments', 'Comments')
        .build()
    );

    if (this.existingSubCompany) {
      form.push(
        this.formlyService.aCheckbox('active', 'Active')
          .build(),

        this.formlyService.aValue('signupUrl', 'Signup URL')
          .withClipboard()
          .build()
      );
    }

    return form;
  }

  private fillFields():void {
    this.formlyService.fillField(this.countryField, this.countryDataService.getAllCountries());

    if (this.existingSubCompany) {
      this.userDataService.createSignupLink( this.model?.company?.id, this.model?.id)
        .then((link:string) => {
          this.form.controls['signupUrl'].setValue(link);
        });
    }
  }
}